import request from '@/utils/request'

// 查询旧VR数据分页
export function orderVr(query) {
    return request({
        url: '/fix/old/vr/page',
        method: 'get',
        params: query,
    })
}
// 查询旧系统施压单分页
export function orderPage(query) {
    return request({
        url: '/fix/old/order/page',
        method: 'get',
        params: query,
    })
}
// 获取旧系统施压单详情
export function orderDetail(query) {
    return request({
        url: '/fix/old/order/detail',
        method: 'get',
        params: query,
    })
}